import * as React from 'react';

export const ReportProviderContext = React.createContext('reportProvider');
